import { useRouter } from 'next/router'
import { useAuth } from '../providers/AuthProvider'
import routes from '../config/routes'
import { useEffect } from 'react'

export default function withAuth(WrappedComponent: any) {
  // eslint-disable-next-line react/display-name
  return () => {
    const { isLoggedIn, isLoading } = useAuth()
    const router = useRouter()

    useEffect(() => {
      if (typeof window === 'undefined' || isLoading || isLoggedIn) return

      void router.replace({
        pathname: routes.login,
        query: { redirect: window.location.pathname },
      })
    }, [isLoading, isLoggedIn, router])

    if (typeof window === 'undefined' || isLoading || !isLoggedIn) return null

    return <WrappedComponent />
  }
}
